import classNames from '@/utils/className';
import { ComponentPropsWithoutRef } from 'react';

export const variants = {
  ChipParent: {
    selected: {
      true: 'selected [&.selected>div]:bg-mglGray300 [&.selected>a]:bg-mglGray300',
    },
    greenBackground: {
      true: '[&>a]:hover:bg-mglGreen600',
    },
  },
  ChipMenuDropdown: {
    isOpen: {
      true: 'opacity-100',
      false: 'opacity-0 pointer-events-none',
    },
  },
  ChipMenuDropdownItem: {
    selected: {
      true: 'selected [&.selected]:bg-mglGray300 [&.selected]:text-mglGray900 [&_path]:[&.selected]:fill-mglGray900',
    },
  },
};

interface ChipParentProps extends ComponentPropsWithoutRef<'div'> {
  selected?: boolean;
  greenBackground?: boolean;
}

export const ChipParent = ({ children, selected = false, greenBackground = false, ...props }: ChipParentProps) => {
  return (
    <div
      className={classNames(
        'hidden tablet:flex',
        variants.ChipParent.greenBackground[greenBackground.toString()],
        variants.ChipParent.selected[selected.toString()]
      )}
      {...props}>
      {children}
    </div>
  );
};

export default { ChipParent };
